export function meetDataFromUrl(url: string): { code: string; tenant?: string } | null {
	// Remove query parameters and fragments from the URL
	const cleanUrl = url.split('?')[0].split('#')[0];
    
	const regex = /\/c\/([^/]+)(?:\/tenant\/([^/]+))?/;
	const match = regex.exec(cleanUrl);

	if (!match) {
		return null;
	}

	return {
		code: match[1],
		tenant: match[2] || undefined
	};
}